import { Card, CardContent } from "@/components/ui/card";
import AppLayout from "@/components/AppLayout";
import PageHero from "@/components/PageHero";
import heroImage from "@/assets/hero-getstarted.jpg";

export default function TermsOfService() {
  return (
    <AppLayout>
      <PageHero
        title="Terms of Service"
        description="Please read these terms carefully before using our platform"
        backgroundImage={heroImage}
      />
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        <Card>
          <CardContent className="pt-6 space-y-6">
            <p className="text-center text-muted-foreground">Last updated: {new Date().toLocaleDateString()}</p>
          <section>
            <h2 className="text-xl font-semibold mb-3">1. Acceptance of Terms</h2>
            <p className="text-sm leading-relaxed">
              By accessing and using Business Consult Market, you accept and agree to be bound by these Terms of Service and our Privacy Policy. These terms are governed by the laws of Zambia.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">2. Services Provided</h2>
            <p className="text-sm leading-relaxed">
              We provide a platform connecting businesses with service providers, including consultancy services, marketplace transactions, funding opportunities, and business tools, operating under Zambian business regulations.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">3. User Responsibilities</h2>
            <ul className="list-disc list-inside space-y-1 text-sm">
              <li>Provide accurate and truthful information</li>
              <li>Comply with all applicable Zambian laws and regulations</li>
              <li>Respect intellectual property rights</li>
              <li>Use the platform for legitimate business purposes only</li>
              <li>Maintain confidentiality of account credentials</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">4. Payment Terms</h2>
            <div className="space-y-2 text-sm">
              <p>• All payments are processed in Zambian Kwacha (ZMW) or USD</p>
              <p>• Payment processing is handled by licensed financial service providers</p>
              <p>• Refunds are subject to our refund policy and Zambian consumer protection laws</p>
              <p>• All transactions are subject to applicable taxes under Zambian tax law</p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">5. Intellectual Property</h2>
            <p className="text-sm leading-relaxed">
              Users retain ownership of their content but grant us a license to use, display, and distribute it on our platform. We respect intellectual property rights under Zambian copyright law.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">6. Limitation of Liability</h2>
            <p className="text-sm leading-relaxed">
              Our liability is limited to the maximum extent permitted by Zambian law. We are not responsible for disputes between users or third-party service failures.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">7. Dispute Resolution</h2>
            <p className="text-sm leading-relaxed">
              Disputes will be resolved through mediation or arbitration in Lusaka, Zambia, in accordance with Zambian arbitration laws. Users may also seek recourse through Zambian courts.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">8. Platform Indemnification</h2>
            <div className="space-y-2 text-sm">
              <p><strong>External Communications:</strong> The platform is indemnified from any conversations, negotiations, or agreements that occur outside our platform. Users engage in external communications at their own risk.</p>
              <p><strong>AI-Generated Content:</strong> Information generated by AI systems on our platform is provided for informational purposes only. Users are solely responsible for verifying the accuracy and completeness of all AI-generated content before making business decisions.</p>
              <p><strong>User Verification:</strong> While we strive to maintain quality standards, users are responsible for conducting their own due diligence and verification of all information, profiles, and claims made by other users on the platform.</p>
              <p><strong>Third-Party Services:</strong> We are not liable for the quality, accuracy, or reliability of services provided by third-party professionals, consultants, or service providers found through our platform.</p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">9. User Communication and Messaging</h2>
            <div className="space-y-2 text-sm">
              <p><strong>Platform Messaging:</strong> Our platform provides messaging capabilities for initial contact and basic communication between users.</p>
              <p><strong>External Communication Disclaimer:</strong> Once users move communications outside our platform (email, phone, in-person meetings), the platform bears no responsibility for the content, outcomes, or consequences of such communications.</p>
              <p><strong>User Safety:</strong> Users should exercise caution when sharing personal information or meeting other users in person. The platform is not responsible for user safety during external interactions.</p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">10. Contact Information</h2>
            <div className="text-sm space-y-1">
              <p><strong>Legal Department:</strong> support@wathaci.com</p>
              <p><strong>Business Address:</strong> Lusaka, Zambia</p>
              <p><strong>Registration:</strong> Registered under Zambian business law</p>
            </div>
          </section>
        </CardContent>
      </Card>
    </div>
    </AppLayout>
  );
}